import { Difficulty } from '../../hooks/gameReducer'
import { isCurrentDailyGame } from '../../lib/gameUtils'

interface Props {
  day: number
  random: number
  difficulty: Difficulty
  solutionCreator?: string
}

export const GameTypeIndicator = ({
  day,
  random,
  difficulty,
  solutionCreator,
}: Props) => {
  const isDailyGame = isCurrentDailyGame(day, random, !!solutionCreator)

  // Don't show anything if it's today's daily game (default state)
  if (isDailyGame) {
    return null
  }

  let label = ''
  let bgColor = ''
  let textColor = ''

  if (solutionCreator) {
    // Custom puzzle
    label = 'Egyedi feladvány'
    bgColor = 'bg-purple-100 dark:bg-purple-800/40'
    textColor = 'text-purple-800 dark:text-purple-200'
  } else if (random > -1) {
    // Random puzzle
    label = 'Véletlen feladvány'
    bgColor = 'bg-blue-100 dark:bg-blue-800/40'
    textColor = 'text-blue-800 dark:text-blue-200'
  } else if (day !== 0) {
    // Past daily puzzle
    const direction = day > 0 ? 'jövőbeli' : 'múltbeli'
    const daysAgo = Math.abs(day)
    label = `${daysAgo}. ${direction} napi feladvány`
    bgColor = 'bg-amber-100 dark:bg-amber-800/40'
    textColor = 'text-amber-800 dark:text-amber-200'
  }

  return (
    <div className="flex justify-center mb-2">
      <div
        className={`px-3 py-1 rounded-full text-xs font-medium ${bgColor} ${textColor}`}
      >
        {label}
      </div>
    </div>
  )
}
